/* eslint-disable no-console */
import { validate } from '../../utils/form-validation-utils';

const contactDealer = (modal) => {
  const form = document.querySelector('.dealer-contact-form');
  const submitBtn = form.querySelector('.button-submit');
  const formErrorDiv = form.querySelector('.form-error-message');
  const formErrorMsg = form.querySelector('.form-error-message span');
  const defaultErrorMsg = formErrorMsg.textContent;
  const resetServerError = (errorDiv, msgDiv, msgText) => {
    errorDiv.classList.add('hidden');
    msgDiv.textContent = msgText;
  };

  const showServerError = (errorDiv, msgDiv, msgText) => {
    errorDiv.classList.remove('hidden');
    msgDiv.textContent = msgText;
  };

  const sendDealerRequest = () => {
    const data = {
      phone: document.getElementById('Phone').value,
      firstName: document.getElementById('FirstName').value,
      lastName: document.getElementById('LastName').value,
      selectedDealerId: document.getElementById('SelectedDealerId').value,
    };
    const url = `/api/PostDealerContactCiUpdate?Phone=${data.phone}&FirstName=${data.firstName}'&LastName=${data.lastName}&SelectedDealerId=${data.selectedDealerId}`;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
      })
        .then((response) => {
          if (response.ok) {
            response.json().then(resolve);
          } else {
            response.json().then(reject);
          }
        })
        .catch(console.error);
    });
  };

  const onSubmitClick = () => {
    const modalDiv = document.querySelector('.site-abandon-dealer-contact-modal');
    const contentDiv = modalDiv.querySelector('.modal-content');
    const altContentDiv = modalDiv.querySelector('.modal-alternate-content');
    sendDealerRequest()
      .then((data) => {
        if (data.success) {
          contentDiv.classList.add('hidden');
          altContentDiv.classList.remove('hidden');
        } else {
          showServerError(formErrorDiv, formErrorMsg, 'Error. Please retry submitting your request.');
        }
        modal.updateHeight();
      });
  };

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    resetServerError(formErrorDiv, formErrorMsg, defaultErrorMsg);
    const isValid = validate(form);
    if (isValid) {
      onSubmitClick();
      return;
    }
    modal.updateHeight();
  });
};

export default contactDealer;
/* eslint-enable no-console */
